/**
 * TKP-121 — görev oluşturma ekranında birden çok atanan: saf yardımcılar (store/Vue yok).
 * Tek atanan → bugünkü tekil kayıt yolu birebir; birden çok → `/task/bulk` (atanan başına ayrı kayıt).
 */
const id = (v) => String((v && v._id) || v || "");

/** Formdaki atanan(lar)ı tekilleştirilmiş diziye çevirir; eski tekil `assignee` alanı da sayılır. */
export const assigneesOf = (form) => {
  const list = Array.isArray(form && form.assignees) ? form.assignees : form && form.assignee ? [form.assignee] : [];
  const seen = new Set();
  return list.filter((a) => a && id(a) && !seen.has(id(a)) && seen.add(id(a)));
};

/**
 * Kayıt planı: `{ mode: "single", payload }` (bugünkü yol; `assignee` tek nesne, `assignees` gönderilmez) ya da
 * `{ mode: "bulk", item, assignees }` (yeni yol). Güncellemede (`_id` var) her zaman tekil.
 */
export const savePlan = (form) => {
  const assignees = assigneesOf(form);
  const { assignees: _drop, ...rest } = form || {};
  if (form && form._id) return { mode: "single", payload: { ...rest, assignee: form.assignee || assignees[0] || null } };
  if (assignees.length > 1) return { mode: "bulk", item: { ...rest, assignee: undefined }, assignees: assignees.map((a) => ({ _id: id(a), name: a.name })) };
  return { mode: "single", payload: { ...rest, assignee: assignees[0] || null } };
};

/** Toplu sonucun kullanıcı mesajı: kaç görev üretildi; üretilemeyenler adıyla. */
export const bulkResultMessage = (result, t) => {
  const created = (result && result.created) || [];
  const failed = (result && result.failed) || [];
  const parts = [t("task.bulk.created", { count: created.length })];
  if (failed.length) parts.push(t("task.bulk.failed", { names: failed.map((f) => (f.assignee && f.assignee.name) || (f.assignee && f.assignee._id) || "?").join(", ") }));
  return { text: parts.join(" "), variant: failed.length ? (created.length ? "warning" : "error") : "success" };
};
